import { render, staticRenderFns } from "./SelectAlgoType.vue?vue&type=template&id=34999752"
import script from "./SelectAlgoType.vue?vue&type=script&lang=ts"
export * from "./SelectAlgoType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports